/* eslint-disable prettier/prettier */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled, { keyframes } from 'styled-components';

interface GridProps {
  active: boolean;
  toggle: boolean;
}

const EaseIn = keyframes`
  from{ opacity:0; }
  to{ opacity:1; }
`;

export const GridContainer = styled.div<GridProps>`
  display: grid;
  grid-template-columns: ${props => (!props.toggle ? '280px 1fr' : '57px 1fr')};
  grid-template-rows: 50px 1fr 50px;
  grid-template-areas:
    'aside header'
    'aside main'
    'aside footer';
  height: 100vh;
  transition: all 0.3s ease;
  animation: ${EaseIn} 0.3s;

  aside {
    transition: all 0.3s ease;
    width: ${props => (!props.toggle ? 'inherit' : '57px')};
  }

  @media only screen and (max-width: 769px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 50px 1fr 50px;
    grid-template-areas:
      'header'
      'main'
      'footer';
    height: 100vh;

    aside {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 280px;
      position: fixed;
      overflow-y: auto;
      z-index: 2;

      transform: ${props =>
    props.active ? 'translateX(0)' : 'translateX(-285px)'};

      .aside_close-icon {
        position: absolute;
        right: 10px;
        top: 23px;
        color: #ffffff;
        font-size: 28px;
      }
    }
  }

  .logo-container {
    a {
      display: ${props => (!props.toggle ? 'block' : 'none')};
    }
  }
`;

export const Header = styled.header`
  grid-area: header;
  background: #3f1159;
  padding: 0 40px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  display: flex;

  .menu-icon {
    position: absolute;
    display: flex;
    top: 0;
    left: 26px;
    align-items: center;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
    padding: 9px;
    font-size: 23px;
    background: var(--purple);
    color: var(--white);
  }

  .header-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: var(--orange);
    font-size: 30px;
    width: 100%;

    h1 {
      font-weight: normal;
      font-size: 2rem;
    }

    .profile {
      display: flex;

      align-items: center;

      .profile-data {
        flex-direction: column;
        padding: 16px;
        height: 50px;
        justify-content: center;
        align-items: left;
        display: flex;

        h3 {
          display: flex;
          flex-direction: column;
          color: var(--white);
          font-family: Source Sans Pro;
          font-style: normal;
          font-weight: bold;
          font-size: 16px;
          line-height: 20px;
          word-break: break-all;

          text-align: right;
          letter-spacing: 0.212019px;
        }

        h3 button {
          display: flex;
          justify-content: flex-end;
          font-family: Source Sans Pro;
          letter-spacing: 0px;
          color: #6d6e71;
          opacity: 1;
          background: transparent;
        }
      }

      .logout-form {
        display: flex;
        align-items: center;
        justify-content: center;

        button {
          border: none;
          background: none;
          padding: 16px;
          font-size: 15px;
          color: #6d6e71;

          display: flex;
          align-items: center;

          svg {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .sair {
    display: flex;
    width: 25px;
    color: var(--white);
    margin-left: auto !important;
    background-color: transparent !important;
  }

  .aside_close-icon {
    position: absolute;
    visibility: visible;
    top: 20px;
    right: 20px;
    font-size: 35px;
    cursor: pointer;
  }

  @media only screen and (min-width: 1441px) {
    padding: 0 10%;
  }

  @media only screen and (min-width: 769px) {
    .menu-icon {
      display: none;
    }
    .aside_close-icon {
      display: none;
    }
  }
`;

export const Main = styled.main`
  grid-area: main;
  background: var(--white);
`;

export const MainOverview = styled.div`
  padding: 0 40px;
  margin-top: 20px;
  animation: ${EaseIn} 0.3s;

  @media only screen and (min-width: 1441px) {
    padding: 0 10%;
  }
`;

export const Footer = styled.footer`
  grid-area: footer;
  background: var(--white);
`;
